/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
	type ApprovalRequest,
	ApprovalRequestFromJSON,
	ApprovalRequestToJSON,
} from '../models/ApprovalRequest';
import {
	type ApprovalResult,
	ApprovalResultFromJSON,
	ApprovalResultToJSON,
} from '../models/ApprovalResult';
import {
	type BaseResponse,
	BaseResponseFromJSON,
	BaseResponseToJSON,
} from '../models/BaseResponse';

export interface ApiV1ApprovePostRequest {
	approvalRequest: ApprovalRequest;
}

export interface ApiV1DisapprovePostRequest {
	approvalRequest: ApprovalRequest;
}

/**
 *
 */
export class SmartClaimsApi extends runtime.BaseAPI {
	/**
	 * Creates request options for apiV1ApprovePost without sending the request
	 */
	async apiV1ApprovePostRequestOpts(
		requestParameters: ApiV1ApprovePostRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['approvalRequest'] == null) {
			throw new runtime.RequiredError(
				'approvalRequest',
				'Required parameter "approvalRequest" was null or undefined when calling apiV1ApprovePost().'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/approve`;

		return {
			path: urlPath,
			method: 'POST',
			headers: headerParameters,
			query: queryParameters,
			body: ApprovalRequestToJSON(requestParameters['approvalRequest']),
		};
	}

	/**
	 */
	async apiV1ApprovePostRaw(
		requestParameters: ApiV1ApprovePostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ApprovalResult>> {
		const requestOptions = await this.apiV1ApprovePostRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalResultFromJSON(jsonValue));
	}

	/**
	 */
	async apiV1ApprovePost(
		requestParameters: ApiV1ApprovePostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ApprovalResult> {
		const response = await this.apiV1ApprovePostRaw(requestParameters, initOverrides);
		return await response.value();
	}

	/**
	 * Creates request options for apiV1DisapprovePost without sending the request
	 */
	async apiV1DisapprovePostRequestOpts(
		requestParameters: ApiV1DisapprovePostRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['approvalRequest'] == null) {
			throw new runtime.RequiredError(
				'approvalRequest',
				'Required parameter "approvalRequest" was null or undefined when calling apiV1DisapprovePost().'
			);
		}

		const queryParameters: any = {};

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/disapprove`;

		return {
			path: urlPath,
			method: 'POST',
			headers: headerParameters,
			query: queryParameters,
			body: ApprovalRequestToJSON(requestParameters['approvalRequest']),
		};
	}

	/**
	 */
	async apiV1DisapprovePostRaw(
		requestParameters: ApiV1DisapprovePostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<ApprovalResult>> {
		const requestOptions = await this.apiV1DisapprovePostRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) => ApprovalResultFromJSON(jsonValue));
	}

	/**
	 */
	async apiV1DisapprovePost(
		requestParameters: ApiV1DisapprovePostRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<ApprovalResult> {
		const response = await this.apiV1DisapprovePostRaw(requestParameters, initOverrides);
		return await response.value();
	}
}
